import {AfterViewInit, Component, Inject, OnDestroy, ViewChild, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ReplaySubject} from "rxjs";
import {AppService} from "@irb/app.service";
import {ICreateModel, ModelsService} from "@irb/irb-models//models-new/models.service";
import {IrbAppEvents, IrbModelsEvents} from "@irb-common/events";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";

@Component({ standalone: false,
  selector: "irb-create-blended-model-dialog",
  templateUrl: "./create-blended-model-dialog.component.html",
  styleUrls: ["./create-blended-model-dialog.component.scss", "../../irb-common/styles/dialog.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CreateBlendedModelDialogComponent implements AfterViewInit {
  @ViewChild("modelNameField") modelNameField: any;
  @ViewChild("modelDescField") modelDescField: any;
  modelName: string = "";
  modelDesc: string;
  modelNameInUse: boolean = false;
  callToActionText: string;
  callBack: Function;
  isAltWorkflow: boolean;
  canNotContinue: boolean = true;
  parseData: any;
  tooltipMessage: any = "";
  tooltipDescMessage: any = "";

  constructor(
    public dialogRef: MatDialogRef<CreateBlendedModelDialogComponent>,
    public modelService: ModelsService,
    public as: AppService,
    private ats: AnalyticsService,
    @Inject(MAT_DIALOG_DATA) public mdd: any
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.modelNameField && this.modelNameField.inputField && this.modelNameField.inputField.nativeElement) {
        this.modelNameField.inputField.nativeElement.focus();
      }
    },100);
  }

  close() {
    this.dialogRef.close();
  }

  checkIfNameExists() {
    this.ats.trackClickEvent("lc_mmc_new_cont");
    const r = {} as ICreateModel;
    r.modelType = "Blended";
    r.modelName = this.modelNameField.inputControl.value;
    r.modelDescription = this.modelDesc;
    this.modelService.createSecurityModel(r).subscribe((data: any) => {
      if (data.alreadyExisting) {
        this.modelNameInUse = true;
      } else {
        data.fullscreen = true;
        data.type = "Blended";
        data.isDraft = true;
        data.onClose = () => {
         this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
           severity: "warn",
           summary: "Incomplete Blended Model",
           detail: "To use this model, allocations must equal 100%."
         });
         this.as.fireEvent(IrbAppEvents.GRID_REFRESH, { 'slot': 'A' });
        };
        if (this.mdd && this.mdd.modelIds)
          data.mmcModelIds = this.mdd.modelIds;
        this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, data);
        this.close();
      }
    });
  }

  onInputChange() {
    setTimeout(() => {
      this.canNotContinue = !this.modelName.trim() || !this.modelNameField.inputControl.valid;

      if (this.modelName.length === 100) {
        this.tooltipMessage = "100 characters max";
      } else {
        this.tooltipMessage = "";
      }
    });
  }
  onDescChange(){
    setTimeout(() => {

      if (this.modelDescField.inputControl.value && this.modelDesc.length === 100) {
        this.tooltipDescMessage = "100 characters max";
      } else {
        this.tooltipDescMessage = "";
      }
    });

  }
}
